import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { EventSubscriptionSettings } from '@ocean/utils/dist/CommunicationObserver'
import { useCommunicationObserver } from 'hooks'
import { routes as homeRoutes } from 'modules/Home/routing'

enum AppName {
  OLP = 'OLP',
}

enum EventName {
  onGoHome = 'onGoHome',
}

// Common layer for microfrontend applications communication
const CommunicationObserverLayer: React.FC = ({ children }) => {
  const history = useHistory()

  const handleGoHome = useCallback(() => {
    history.push(homeRoutes.root)
  }, [history])

  const events = useMemo(() => {
    const GoHomeEvent: EventSubscriptionSettings = {
      callback: handleGoHome,
      name: EventName.onGoHome,
      recipient: AppName.OLP,
    }
    return [GoHomeEvent]
  }, [handleGoHome])

  useCommunicationObserver(events)

  return <>{children}</>
}

export default CommunicationObserverLayer
